import * as actionTypes from './actionTypes';
import { serviceAnnouncement } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { hydrateDataSendForDelete } from './hydrators';
import { fetchValidate } from '@app/src/common/session';

const fetchAnnouncementRequest = () => ({
  type: actionTypes.FETCH_ANNOUNCEMENT_REQUEST
});

const fetchAnnouncementSuccess = (data) => ({
  type: actionTypes.FETCH_ANNOUNCEMENT_SUCCESS,
  data
});

const fetchAnnouncementFailure = () => ({
  type: actionTypes.FETCH_ANNOUNCEMENT_FAILURE
});

const deleteAnnouncementRequest = () => ({
  type: actionTypes.DELETE_ANNOUNCEMENT_REQUEST
});

const deleteAnnouncementSuccess = (data) => ({
  type: actionTypes.DELETE_ANNOUNCEMENT_SUCCESS,
  data
});

const deleteAnnouncementFailure = () => ({
  type: actionTypes.DELETE_ANNOUNCEMENT_FAILURE
});

export const selectAnnouncement = (uniqueId: string, checked: boolean) => ({
  type: actionTypes.SELECT_ANNOUNCEMENT,
  uniqueId,
  checked
});

export const clearAnnouncementDeleteData = () => ({
  type: actionTypes.CLEAR_ANNOUNCEMENT_DELETE_DATA
});

export const clearAnnouncementPutInactiveData = () => ({
  type: actionTypes.CLEAR_ANNOUNCEMENT_PUT_INACTIVE_DATA
});


const republishAnnouncementRequest = () => ({
  type: actionTypes.REPUBLISH_ANNOUNCEMENT_REQUEST
});

const republishAnnouncementSuccess = (data) => ({
  type: actionTypes.REPUBLISH_ANNOUNCEMENT_SUCCESS,
  data
});

const republishAnnouncementFailure = () => ({
  type: actionTypes.REPUBLISH_ANNOUNCEMENT_FAILURE
});

export const clearAnnouncementSelecteds = () => ({
  type: actionTypes.CLEAR_ANNOUNCEMENT_SELECTEDS
});

export const clearAnnouncementRepublishData = () => ({
  type: actionTypes.CLEAR_ANNOUNCEMENT_REPUBLISH_DATA
});

export const setAnnouncementState = (state: number) => ({
  type: actionTypes.SET_ANNOUNCEMENT_STATE,
  state
});

export const setAnnouncementPage = (page: number) => ({
  type: actionTypes.SET_ANNOUNCEMENT_PAGE,
  page
});

const putAnnouncementRequest = () => ({
  type: actionTypes.PUT_ANNOUNCEMENT_REQUEST
});

const putAnnouncementSuccess = (data) => ({
  type: actionTypes.PUT_ANNOUNCEMENT_SUCCESS,
  data
});

const putAnnouncementFailure = () => ({
  type: actionTypes.PUT_ANNOUNCEMENT_FAILURE
});

export const fetchAnnouncement = (userId: string, page: number, state: number): Function => {
  return async dispatch => {
    dispatch(fetchAnnouncementRequest());
    await dispatch(fetchValidate());
    try {
      const data = await serviceAnnouncement.post(userId, { page, state });
      dispatch(fetchAnnouncementSuccess(data));
    } catch (e) {
      dispatch(fetchAnnouncementFailure());
      dispatch(actionsModalError.openModalError());
      console.log(`Error action fetch my announcement: ${e}`);
    }
  }
};

export const deleteAnnouncement = (selecteds: any[]): Function => {
  return async dispatch => {
    dispatch(deleteAnnouncementRequest());
    await dispatch(fetchValidate());
    try {
      const data = await serviceAnnouncement.delete(hydrateDataSendForDelete(selecteds));
      dispatch(deleteAnnouncementSuccess(data));
    } catch (e) {
      dispatch(deleteAnnouncementFailure());
      dispatch(actionsModalError.openModalError());
      console.log(`Error action delete my announcement: ${e}`);
    }
  }
};

export const putAnnouncementInactive = (selecteds: any[]): Function => {
  return async dispatch => {
    dispatch(putAnnouncementRequest());
    await dispatch(fetchValidate());
    try {
      const data = await serviceAnnouncement.setInactive(hydrateDataSendForDelete(selecteds));
      dispatch(putAnnouncementSuccess(data));
    } catch (e) {
      dispatch(putAnnouncementFailure());
      dispatch(actionsModalError.openModalError());
      console.log(`Error action put inactive my announcement: ${e}`);
    }
  }
};

export const republishAnnouncement = (userId: string, categoryId: number, uniqueId: string): Function => {
  return async dispatch => {
    dispatch(republishAnnouncementRequest());
    await dispatch(fetchValidate());
    try {
      const data = await serviceAnnouncement.getRepublish(userId, categoryId, uniqueId);
      dispatch(republishAnnouncementSuccess(data && data[0]));
    } catch (e) {
      dispatch(republishAnnouncementFailure());
      dispatch(actionsModalError.openModalError());
      console.log('Error action fetch republish Announcement: ', e);
    }
  }
};